import React from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

const FooterPanel = ({ children, changeEv }) => {
    return (
        <div className="sign__form--footer">
            <Button variant="link" onClick={() => changeEv()}>
                {children}
            </Button>
        </div>
    );
};

FooterPanel.propTypes = {
    changeEv: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
};

export default FooterPanel;
